export default __webpack_public_path__ + "static/media/Hartford.1cd4e5f1.png";